import React, { useCallback } from 'react';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { DropDownMenu } from '../../drop-down-menu/drop-down-menu.js';
import { Option } from '../../option/option.js';
import { TextType } from '../../text/text-constants.js';
import { Text } from '../../text/text.js';
function TimelineSelector(props) {
    const { items, onChange, title } = props;
    const onItemClick = useCallback((item) => {
        if (isFunction(onChange)) {
            onChange(item);
        }
    }, []);
    return (React.createElement(DropDownMenu, { uuid: "timeline-selector-uuid" },
        React.createElement("div", { slot: "header" },
            React.createElement(Text, { type: TextType.SECONDARY, value: title })),
        React.createElement("div", { slot: "content" }, items.map((item) => {
            return (React.createElement(Option, { key: item, onClick: () => onItemClick(item), preventDefault: true, stopPropagation: false, value: item }));
        }))));
}
export { TimelineSelector, };
//# sourceMappingURL=timeline-selector.js.map